import type { ReactNode } from "react";
import { Outlet, useLocation } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";
import TopBar from "./TopBar";

/**
 * The crash screen, keyed on the path: moving to another page clears it.
 * No onError: there is no app logger yet (fetch-logger is API calls only),
 * so the crash goes to the console.
 */
export function PageBoundary({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  return (
    <ErrorBoundary key={pathname} buttonClassName="btn" primaryButtonClassName="btn primary">
      {children}
    </ErrorBoundary>
  );
}

/** Every page but the player: the top bar, and the page below it, where a crash stays. */
export function SiteLayout() {
  const { pathname } = useLocation();
  return (
    <div className={`app ${pathname === "/" ? "home" : "about"}`}>
      <TopBar />
      <main>
        <PageBoundary>
          <Outlet />
        </PageBoundary>
      </main>
    </div>
  );
}
